export const getDefault = () => {
  const schema = {
    name: 'Campus',
    backgroundColor: '#fff',
    textColor: '#000',
    title: 'Highlights',
    showHeader: false,
    isMarkdown: true,
    data: [
      {
        backgroundColor: '#fff',
        backgroundImage: 'https://static.ua.pt/images/ua/placeholder-bw.png',
        textColor: '#000',
        text: 'Titulo',
        alt: 'Imagem exemplo',
        href: '/',
        hasText: true,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias animi atque.'
      },
      {
        backgroundColor: '#fff',
        backgroundImage: 'https://static.ua.pt/images/ua/placeholder-bw.png',
        textColor: '#000',
        text: 'Titulo 2',
        alt: 'Imagem exemplo',
        href: '/',
        hasText: true,
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias animi atque.'
      },
    ]
  }
  return schema
}
